<template>
    <div class="slider-pagination d-flex justify-content-sm-center">
        <div class="d-flex">
            <div :id="idPrev" class="swiper-button-prev" slot="button-prev"></div>
            <div :id="idNext" class="swiper-button-next" slot="button-next"></div>
        </div>
        <template v-if="navigationBtn">
            <a :href="navigationBtn.href" class="btn">{{ navigationBtn.text }}</a>
        </template>
    </div>
</template>

<script>
export default {
    name: "SliderPagination",
    props: {

        idPrev: {
            required: true,
            type: String
        },

        idNext: {
            required: true,
            type: String
        },

        navigationBtn: {
            type: Object,
            default: null
        }

    }

}
</script>
